// /restaurants/:restaurantId/orders/${orderId}/change-status
import API from '../axios/API';
import * as types from '../../reduxStore/types/orders';

const COMPLETED_STATUSES = ['customer_picked_up', 'delivered', 'rider_delivered', 'restaurant_cancelled'];

export const liverOrderStatusChange = (data) => {
    return async (dispatch, getState) => {
        let response;
        let { orders } = getState();
        const orderId = orders.selectedOrderId;

        try {
            response = await API.patch(
                `/restaurants/:restaurantId/orders/${orderId}/change-status`,
                data
            );
        } catch (error) {
            response = error;
        }

        if (response.success) {
            // We know the status we sent — use it for immediate UI update
            const newStatus = data.status;

            if (COMPLETED_STATUSES.includes(newStatus)) {
                // Completed order — remove from live list immediately
                dispatch({
                    type: types.REMOVE_COMPLETED_ORDER,
                    payload: orderId,
                });
            } else {
                // Active order — update status in-place using what we know
                const now = new Date().toISOString();
                const statusUpdate = { delivery_status: newStatus };
                if (newStatus === 'restaurant_accepted') statusUpdate.restaurant_accepted_at = now;
                if (newStatus === 'restaurant_ready') statusUpdate.restaurant_ready_at = now;

                // Use response.order if available (has full data), otherwise build from what we know
                const orderData = response.order || {
                    ...statusUpdate,
                    status: {
                        ...(orders.selectedOrderDetails?.status || {}),
                        ...statusUpdate,
                    },
                };

                dispatch({
                    type: types.SYNC_ORDER_STATUS_IN_LIST,
                    payload: {
                        orderId: orderId,
                        orderData: orderData,
                    },
                });
            }
        }

        return response;
    };
};
